import {required} from "vuelidate/lib/validators";

export const awsS3Compatible = (regionOptions, regionPlaceholder) => (
  {
    rows: [
      {
        blocks: [
          {
            fields: [
              {
                name: 'bucketName',
                type: 'text',
                placeholder: 'Bucket name'
              },
              {
                name: 'accessKey',
                type: 'text',
                placeholder: 'Access key'
              },
              {
                name: 'secretKey',
                type: 'text',
                placeholder: 'Secret key'
              },
              {
                name: 'region',
                label: '',
                type: 'i-dropdown',
                placeholder: regionPlaceholder,
                allowEmpty: false,
                options: regionOptions
              },
              {
                name: 'endpointUrl',
                type: 'text',
                placeholder: 'S3 compatible endpoint'
              },
            ]
          },
        ]
      }
    ],
    validations: {
      bucketName: {
        required
      },
      accessKey: {
        required
      },
      secretKey: {
        required
      },
      region: {
        required
      },
      endpoint: {
        required
      }

    },
    errors: {
      bucketName: {
        required: "Bucket name is required",
      },
      accessKey: {
        required: "Access key is required",
      },
      secretKey: {
        required: "Secret key is required",
      },
      region: {
        required: "Region is required",
      },
      endpoint: {
        required: "Endpoint is required",
      }
    }
  })
